import Http from "@/commons/Http";
import Utils from "@/commons/Utils.js";

const path = 'api/modelo-textual';

export default {

  async getAll(resetCache = ''){
    return Http.get(`${path}${resetCache ? '?reset=' + resetCache : ''}`);
  },

  // Somente ativos. Espelha GET /simple, que agora filtra ativo IS TRUE no repositório.
  async getSimpleList(){
    return Http.get(`${path}/simple`);
  },

  // Ativos e inativos. É o que a tela de lista consome, porque ela filtra ativo/inativo no cliente
  // (views/Administracao/base/List.vue) — com /simple a aba "Inativos" ficaria sempre vazia.
  async getAllSimpleList(){
    return Http.get(`${path}/all-simple`);
  },

  async getById(id){
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}`);
  },

  async save(dto, id = ''){
    return Http.post(`${path}/${id}`, dto);
  },

  async listByTipo(tipo, atribuicao){
    return Http.get(`${path}/${tipo}/${atribuicao}/simples`);
  },

  // Tipos de modelo com as regras de atribuição/Word resolvidas no backend.
  async getTipos(){
    return Http.get(`${path}/tipos`);
  },

  // Validação informativa de um template de minuta (variáveis, escopo, tags, fragmentos).
  async validarMinuta(minuta, tipo){
    return Http.post(`${path}/validar`, {minuta, tipo});
  },

}
